import React, { Component } from 'react'
import { observer } from 'mobx-react'
import DragAndDrop from '@ui/DragAndDrop'
import Row from './Row'
import './styles.scss'

@observer
export default class MultipleRating extends Component {
  handleSelect = async (row, value) => {
    const { selected, onSelect } = this.props
    const newValues = { ...selected, [row]: value }
    if (onSelect) onSelect(newValues, row, value)
  }

  render() {
    const {
      columns,
      rows,
      selected,
      editable,
      onRemove,
      onDrag,
      onDrop,
      inactive,
      mode,
      textDirection,
      variablesOptions,
      onChange,
      onEdit,
      splitted,
      dontKnowButton,
      legends
    } = this.props

    return (
      <DragAndDrop
        itemType='row'
        onMove={onDrag}
        onDrop={onDrop}
        containerClassName='matrix-container'
        dir={textDirection}
        list={rows.map((row, index) => ({
          index,
          id: row.id,
          editable,
          children: (
            <Row
              key={row.value}
              index={index}
              row={row}
              id={row.id}
              title={row.text}
              focus={row.focus}
              name={row.value}
              columns={columns}
              onSelect={this.handleSelect}
              onEdit={onEdit}
              onChange={onChange}
              currentValue={
                selected && row.value in selected ? selected[row.value] : undefined
              }
              editable={editable}
              onRemove={onRemove}
              inactive={inactive}
              mode={mode}
              variablesOptions={variablesOptions}
              splitted={splitted}
              dontKnowButton={dontKnowButton}
              legends={legends}
            />
          )
        }))}
      />
    )
  }
}
